import actionTypes from "./actionTypes";
import * as verifyUtils from "../utils/verifyUtils";

const verifyGUIDRequest = () => ({
  type: actionTypes.VERIFY_GUID_REQUEST,
});
const verifyGUIDSuccess = (res) => ({
  type: actionTypes.VERIFY_GUID_SUCCESS,
  res,
});
const verifyGUIDFailure = (error) => ({
  type: actionTypes.VERIFY_GUID_FAILURE,
  error,
});
export const GUID = (guid) => {
  return async (dispatch) => {
    try {
      dispatch(verifyGUIDRequest());
      let res = await verifyUtils.GUID(guid);
      dispatch(verifyGUIDSuccess(res));
    } catch (error) {
      dispatch(verifyGUIDFailure(error));
    }
  };
};

const verifyEmailAndPassRequest = () => ({
  type: actionTypes.VERIFY_EMAIL_AND_PASS_REQUEST,
});
const verifyEmailAndPassSuccess = (res) => ({
  type: actionTypes.VERIFY_EMAIL_AND_PASS_SUCCESS,
  res,
});
const verifyEmailAndPassFailure = (error) => ({
  type: actionTypes.VERIFY_EMAIL_AND_PASS_FAILURE,
  error,
});
export const emailAndPass = (data) => {
  return async (dispatch) => {
    try {
      dispatch(verifyEmailAndPassRequest());
      let res = await verifyUtils.emailAndPass(data);
      dispatch(verifyEmailAndPassSuccess(res));
    } catch (error) {
      dispatch(verifyEmailAndPassFailure(error));
    }
  };
};
